import { render } from "./License.vue?vue&type=template&id=abdc599e&scoped=true"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"

import "./License.vue?vue&type=style&index=0&id=abdc599e&lang=scss&scoped=true"

import exportComponent from "/app/code_base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abdc599e"]])

export default __exports__